export const GET_ALL_DIVISION_NAMES = {
    INIT: "GET_ALL_DIVISION_NAMES_INIT",
    SUCCESS: "GET_ALL_DIVISION_NAMES_SUCCESS",
    ERROR: "GET_ALL_DIVISION_NAMES_ERROR",
};
